export const StorageKeys = {
  TIMESHEET_RETURN_URL_KEY: 'timesheet_return_url',
  REFERENTIAL_RETURN_TIMESHEET_KEY: 'referential_return_timesheet',
  REFERENTIAL_CATEGORY_CODE_KEY: 'referential_category_code',
};
